import React, { useState } from 'react';
import Title from "../UI/Text/Title";
import DashboardLayout from "../UI/Layout/DashboardLayout";
import Alert from "../UI/Alert/Alert";
import Card from "../UI/Card/Card";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactDatePicker from "react-datepicker";
import { faCalendarAlt, faDownload } from '@fortawesome/free-solid-svg-icons';
import { NODE_HOST_URL } from './api/Api';

import "react-datepicker/dist/react-datepicker.css";

const ConversationDownload = () => {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage?.user?.userId;
    const token = lStorage?.token;

    const [error, setError] = useState({
        status: false,
        message: "",
        color: ""
    });

    const [fromdate, setFromdate] = useState(null);
    const [todate, setTodate] = useState(null);

    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return (
        <DashboardLayout>
            <main className="content">
                <div className="container-fluid p-0">
                    <Title isButton={false}> Conversation Download </Title>

                    {error.status && (
                        <Alert type={error.color}>
                            {error.message}
                        </Alert>
                    )}

                    <Card CardTitle="Download Conversation Report">
                        <div className="row g-4 align-items-end">
                            <div className="col-md-4">
                                <label htmlFor="fromDate" className="form-label">
                                    From Date
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text">
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                    </span>
                                    <ReactDatePicker
                                        id="fromDate"
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        selected={fromdate}
                                        onChange={setFromdate}
                                        placeholderText="Select from date"
                                        maxDate={new Date()}
                                        isClearable
                                    />
                                </div>
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="toDate" className="form-label">
                                    To Date
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text">
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                    </span>
                                    <ReactDatePicker
                                        id="toDate"
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        selected={todate}
                                        onChange={setTodate}
                                        placeholderText="Select to date"
                                        maxDate={new Date()}
                                        isClearable
                                    />
                                </div>
                            </div>

                            <div className="col-md-4 text-end mt-3 mt-md-0">
                                <a
                                    href={`${NODE_HOST_URL}/rcs?user_id=${user_id}&token=${token}&method=conv_report_download&from_date=${formatDate(fromdate)}&to_date=${formatDate(todate)}`}
                                    className="btn btn-success d-inline-flex align-items-center gap-2"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FontAwesomeIcon className='mr-2' icon={faDownload} />
                                    Download Report
                                </a>
                            </div>
                        </div>
                    </Card>
                </div>
            </main>
        </DashboardLayout>
    );
};

export default ConversationDownload;
